// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1ENW0","search":"Settings_search__2WGUa","filter":"Settings_filter__19kPU"};